import React, { useState } from 'react';
import { ChevronDownIcon, DropletIcon } from 'lucide-react';
import { tips } from '../../data/eau';
export function WaterTips() {
  const [openId, setOpenId] = useState<string | null>(tips[0].id);
  return <section aria-labelledby="conseils-titre" data-id="element-1357" data-mp="uupo5j3ih92a">
      <h2 id="conseils-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-1358" data-mp="yuztctjhbvg3">
        Réduire ma consommation
      </h2>
      <p className="mt-2 max-w-2xl text-[15px] text-slate-600" data-id="element-1359" data-mp="1mlnewhmbijl4">
        Quatre gestes classés par économie estimée pour une résidence de Baie-Trinité.
      </p>

      <ul className="mt-5 space-y-3" data-id="element-1360" data-mp="1djw9zezlqgsb">
        {tips.map(tip => {
        const open = tip.id === openId;
        return <li key={tip.id} className="rounded-2xl border border-slate-200 bg-white" data-id="element-1361" data-mp="1ii7hvk6c6h7w">
              <h3 data-id="element-1362" data-mp="247neoq9fjs1">
                <button type="button" onClick={() => setOpenId(open ? null : tip.id)} aria-expanded={open} className="flex w-full items-center gap-3 px-5 py-4 text-left transition-colors duration-150 ease-ville hover:bg-ville-indigo-soft/40 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1363" data-mp="23plpcktwdcq">
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-ville-indigo-soft text-ville-indigo" aria-hidden="true" data-id="element-1364" data-mp="23xjpwiobbr5s">
                    <DropletIcon className="h-4 w-4" data-id="element-1365" data-mp="2cvvslj2gefel" />
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-1366" data-mp="27xc53e87ovk4">
                    <span className="block text-[15px] font-bold text-ville-navy" data-id="element-1367" data-mp="27wj28ocdiq79">{tip.title}</span>
                    <span className="block text-[13px] font-semibold text-ville-indigo" data-id="element-1368" data-mp="2mp4aoyi7ev8n">
                      Économie estimée : {tip.saving}
                    </span>
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-slate-400 transition-transform duration-150 ease-ville ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-1369" data-mp="2vllipsv9ud06" />
                </button>
              </h3>
              {open && <p className="px-5 pb-5 text-[15px] leading-relaxed text-slate-600" data-id="element-1370" data-mp="38n76sfzxyr1h">{tip.detail}</p>}
            </li>;
      })}
      </ul>
    </section>;
}